module.exports = __webpack_public_path__ + "img/Avatar-90.c5268180.svg";